/**
 * @file: OrderSourceType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum OrderSourceType {
  Default = 'default',
  OpenApi = 'openapi',
  Extension = 'extension',
  Hosted = 'hosted',
}

export const OrderSourceTypeValueSet = new Set([
  OrderSourceType.Default,
  OrderSourceType.OpenApi,
  OrderSourceType.Extension,
  OrderSourceType.Hosted,
]);
